<!-- Blank Mega Menu Component -->
<script setup lang="ts">
import { useContentStore } from '@/stores/content';
const $content = useContentStore();

import iconSolution from "@/components/icons/iconSolution.vue";
import iconChemicals from "@/components/icons/iconChemicals.vue";
import iconManufactured from "@/components/icons/iconManufactured.vue";
import iconManufacturing from "@/components/icons/iconManufacturing.vue";
import iconSupportWaste from "@/components/icons/iconSupportWaste.vue";
import iconIndustry from "@/components/icons/iconIndustry.vue";
import iconApplications from "@/components/icons/iconApplications.vue";

import ProductsCategoryCardMega from "@/components/cards/ProductsCategoryCardMega.vue";

import { vwWithMax } from '~/utility/utility';

const defultWidth = computed(() => {
  // During SSR, return a consistent fallback value to prevent hydration mismatches
  if (typeof window === 'undefined') {
    return '1300px' // Use max width during SSR for consistency
  }
  return vwWithMax(80, 1300) + "px"
});

const route = useRoute();
const router = useRouter();

const redirect = (path: string) => {
  router.push(path);
}
const categories = computed(() => $content.productCategories);
</script>

<template>
  <Frame id="mega-catalogue" class="io-mega-popover sec-popover-container popover-media mega-catalogue">
    <Frame class="sec-mega-container" w="grid grid-cols-[1fr_1fr_1fr] g-0">
      <Frame class="flex-1" w="grid g-0.5">
      <!-- <div class="mega-column-title">
          <div>Chemistry</div>
      </div> -->
      <div class="sec-link-cards grid">
        <ProductsCategoryCardMega :category="categories[0]" />
        <ProductsCategoryCardMega :category="categories[1]" />
      </div>
    </Frame>
    <Frame class="flex-1" w="grid g-0.5">
      <!-- <div class="mega-column-title">
          <div>Services</div> 
      </div> -->
      <div class="sec-link-cards grid">
        <ProductsCategoryCardMega :category="categories[2]" />
        <ProductsCategoryCardMega :category="categories[3]" />
      </div>
    </Frame>
    <Frame class="flex-1" w="grid g-0.5">

      <!-- <div class="mega-column-title">
          <div>Industries & Applications</div>
      </div> -->
      <div class="sec-link-cards grid">
        <ProductsCategoryCardMega :category="categories[4]" />
        <ProductsCategoryCardMega :category="categories[5]" />
      </div>
    </Frame>
    </Frame>
  </Frame>
</template>

<style lang="scss" scoped>

.mega-catalogue {
  .sec-mega-container {
    padding: gr(1);
  }
}

#mega-catalogue {
  width: v-bind(defultWidth);

  .tag-soon {
    background: #f1f5f9;
    font-size: fs(-3);
    padding: 0.12rem 0.4rem;
    color: #475569;
    @apply rounded-md;
  }

  .sec-nav-card-link {
    &.feature {
      .wrap {
        .icon {
          svg {
            width: 24px;
            height: auto;

            &.ethanol {
              * {
                fill: var(--blue-500);
              }
            }

            &.chemical {
              * {
                fill: var(--purple-800);
              }
            }

            &.manufactured {
              * {
                fill: var(--emerald-500);
              }
            }
          }


        }
      }
    }
  }
}
</style>